"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getChallengeConditions = _interopRequireDefault(require("./getChallengeConditions"));

var hasMultipleConditions = function hasMultipleConditions(_ref) {
  var conditions = _ref.conditions;

  if (conditions.combinations && conditions.combinations.length > 0) {
    return conditions.combinations.length > 1;
  }

  var result = (0, _getChallengeConditions["default"])(conditions);
  return result.length > 1;
};

var _default = hasMultipleConditions;
exports["default"] = _default;
//# sourceMappingURL=hasMultipleConditions.js.map